import styled from 'styled-components';
import WebsiteImage from 'components/WebsiteImage';

export const SectionContainer = styled.div`
  background: white;

  .section-tool-page-hero--wrapper {
    background: ${props => `url(${props.backgroundImg || props.placeholderBackgroundImg})`};
    background-repeat: no-repeat;
    background-size: ${props => props.backgroundImg ? 'cover' : '100% 680px'};
  }

  .section-tool-page-hero--container {
    margin: 0 auto;
    padding: ${props => (props.noBreadCrumb ? '60px' : '100px')} 0
      ${props => (props.noOverlap ? '' : '150px')};
    display: flex;
    justify-content: center;
    flex-direction: column;

    .section-tool-page-hero--title {
      font-size: 61px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.05em;
      color: var(--white-color);
      max-width: 990px;
      margin: 0 auto;
      padding: 0 28px;
    }

    .section-tool-page-hero--description {
      font-weight: 500;
      font-size: 20px;
      line-height: 150%;
      color: var(--white-color);
      text-align: center;
      max-width: 990px;
      margin: 0 auto;
      margin-top: 24px;
      padding: 0 28px;

      .section-tool-page-hero--subheading-image {
        width: 65%;

        @media (max-width: 576px) {
          width: 80%;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .section-tool-page-hero--container {
      padding-bottom: ${props => (props.noOverlap ? '60px' : '100px')};

      .section-tool-page-hero--title {
        font-size: 32px;
        letter-spacing: -0.03em;
      }

      .section-tool-page-hero--description {
        font-size: 17px;
        margin-top: 16px;
      }

      .section-tool-page-hero--main {
        margin-top: 40px;
        padding: 0 20px;
      }
    }
  }

  @media (max-width: 576px) {
    .section-tool-page-hero--container {
      padding-top: ${props => (props.noBreadCrumb ? '50px' : '90px')};
    }
  }
`;

export const FormContainer = styled.div`
  background: transparent;
  margin-top: ${props => (props.isEmbed ? '0 !important' : '-90px')};

  .section-tool-page-form--container {
    max-width: 1046px;
    margin: 0 auto;
    padding: 0 28px;

    ${props => (props.isEmbed ? `& > div {box-shadow: none !important;}` : '')}
  }

  @media (max-width: 768px) {
    margin-top: -50px;

    .section-tool-page-form--container {
      padding: 0 20px;
    }
  }
`;

export const DescriptionContainer = styled.div`
  max-width: 1046px;
  margin: 70px auto;
  padding: 0 28px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const EmbedLinkModalContainer = styled.div`
  padding: 20px;
  .tools-embed-link--title {
    font-size: 31px;
  }

  .tools-embed-link--description {
    font-size: 16px;
  }

  .tools-embed-link--iframe-code {
    padding: 19px;
    border: 1px solid #cfd8dc;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
  }

  .tools-embed-link--button-group {
    display: flex;
    justify-content: flex-end;

    button,
    a {
      margin-left: 15px;
      width: 109px;
    }
  }
`;

export const GateFormContainer = styled.div`
  .section-gate-form--submit-form {
    .section-gate-form--submit-form-title {
      font-weight: 900;
      font-size: 31px;
      line-height: 110%;
      display: flex;
      align-items: center;
      letter-spacing: -0.03em;
      color: var(--black-color);
    }

    .gate-form--subscribe-form {
      margin-top: 20px;
      display: flex;
      flex-direction: column;

      .gate-form--subscribe-marketo-form {
        box-shadow: none !important;
        padding: 0;

        .data-layer-form {
          flex-direction: column;

          .ant-row.ant-form-item {
            width: 100%;
            margin-bottom: 12px;
          }

          .text-field-wrapper .text-field-input {
            width: 100%;
          }

          button {
            box-shadow: none;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .section-gate-form--submit-form {
      button {
        padding: 11px 24px;
      }
    }
  }
`;

export const ToolSectionContainer = styled.div`
  padding: 78px 0 76px;
  max-width: 1189px;
  margin: 0 auto;
`;

export const ToolSectionFormStep = styled.div`
  display: flex !important;
  height: 190px;

  @media (max-width: 952px) {
    flex-direction: column;
    min-height: 384px;
    height: auto;
  }
`;

export const ToolSectionProgressArea = styled.div`
  max-width: 452px;
  margin: 50px auto 0;
  padding: 0 20px;

  @media (max-width: 952px) {
    max-width: 100%;
  }
`;

export const EmbedLinkContainer = styled.div`
  display: flex;
  margin-top: 30px;
  cursor: pointer;

  p {
    font-size: 20px;
    margin: 5px 0 0 4px;
  }
`;

export const HeroSubheadingWebsiteImage = styled(WebsiteImage)`
  margin: 20px auto 40px auto;
`;
